export default function noticeError(error, attributes = {}) {
    window?.newrelic?.noticeError(error, attributes);
}
